import { render, staticRenderFns } from "./modalImprimirCertificadoManoObra.vue?vue&type=template&id=07654b9f&"
import script from "./modalImprimirCertificadoManoObra.vue?vue&type=script&lang=js&"
export * from "./modalImprimirCertificadoManoObra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports